module.exports = "/assets/site/images/mvmse_logo_news_placeholder.png?f742c472615179ac17331bbddf28d842";